export default __webpack_public_path__ + "static/walimatul-ursy-b-d5b15b89f567bfc36b267ec201d32eb4.webp";